import React from "react";
import styled from "styled-components/macro";
import "../index.css";

import NavResponsive from "./NavResponsive";

const NavBarHome = () => {
  return (
    <Nav>
      <NavResponsive />
    </Nav>
  );
};

export default NavBarHome;

const Nav = styled.nav`
  background-color: var(--clr-grey);
  width: 100%;
  color: var(--clr-light);
  font-family: "Poppins", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  margin-top: 0.5rem;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 0;
    margin: 0;
  }
`;
